import axiosClient from "./axiosClient";

const meApi = {
  getMyProfile(): Promise<any> {
    const url = `adminUserManage/me`;
    return axiosClient.get(url);
  },
};

export default meApi;
